// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { BreadcrumbTokens } from './type';

const breadcrumbTokens: BreadcrumbTokens = {
  breadcrumbFontSize: '14/regular',
  breadcrumbFontColor: 'Neutral-text-5',
  breadcrumbLinkColor: 'Neutral-text-3',
  breadcrumbLinkHoverColor: 'Brand-5',
  breadcrumbListBackgroundColor: 'Neutral-fill-1',
  breadcrumbListShadow: 'Shadow-1',
  breadcrumbListBorderColor: '#f4f5f8',
  breadcrumbListPaddingY: 'Padding-4',
  breadcrumbListItemBorderRadius: 'Radius-4',
  breadcrumbListItemWrapperPaddingX: 'Padding-4',
  breadcrumbListItemPaddingX: 'Padding-8',
  breadcrumbListItemPaddingY: 'Padding-5',
  breadcrumbListItemHoverBackgroundColor: 'Neutral-fill-2',
  breadcrumbListItemHoverFontColor: 'Neutral-text-3',
  breadcrumbSeparatorMarginX: 'Padding-8',
  breadcrumbIconBackgroundColor: 'Neutral-text-4',
};

export default breadcrumbTokens;
